<div class="container">
  <div class="row justify-content-md-center ">
    <div clas="col col-lg-8">
      <div class="card mb-3">
        <div class="card-header backgroundHeader text-center">
          Ocorreu um ERRO no Conectividade Social - ICP!
        </div>
        <div class="card-body backgroundBody text-center">
          <p class="card-text">
             A URL informada não foi encontrada.
        </div>
      </div>
    </div>
  </div>
</div>